<template>
<div
  class="empty-mealtime-slot"
  @click.stop="
    () => {
      return;
    }
  "
>
  <h4>{{ $t('calender.lblNothingSchedule') }} {{ this.mealtime }}.</h4>

  <BaseButton
    type="button"
    @click.stop="
      () => {
        $emit('show-recipes');
      }
    "
  >
    <BaseIcon class="icon-add-dish" name="plus" />{{ $t('calender.lblAddRecipe') }}
  </BaseButton>
</div>
</template>

<script>
export default {
  props: {
    isEmbed: {
      type: Boolean,
    },
    mealtime: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.empty-mealtime-slot {
  padding: 1.7rem 3rem;
  text-align: center;

  // iPhone 6 up
  @include media('md', null) {
    padding: 1.7rem 6rem;
  }

  h4 {
    font-size: 1.6rem;
    line-height: 1.3;
    margin-bottom: 1rem;
  }

  .btn-add-recipe {
    background-color: $color-action;
    border-radius: 1rem;
    color: white;
    font-size: 1.6rem;
    font-weight: 400;
    padding: 0.2rem 0.9rem;

    // iPhone 6 up
    @include media('md', null) {
      padding: 0.2rem 0.8rem;
    }

    span {
      display: none;

      // iPhone 6 up
      @include media('md', null) {
        display: inline-block;
      }
    }
  }
}
</style>
